<template>
  <div>
    <span v-if="step.status == 2">
      {{ getTranslatedContent(step) }}
    </span>
    <span v-else-if="step.status == 1">
      {{ getTranslatedContent(step) }}

      <div v-if="step.link.evaluation_url">
        <a :href="step.link.evaluation_url" target="_blank">
          {{ $t(step.link.text) }}
        </a>
      </div>
      <div v-else>
        <router-link :to="{ name: step.link.name, params: step.link.params }" v-slot="{ navigate, href, isExactActive }">
          <a :href="href" @click="navigate" :class="{ active: isExactActive }">
            <span>{{ $t(step.link.text) }}</span>
          </a>
        </router-link>
      </div>
    </span>
    <span v-else-if="step.status == 0">
      {{ step.content }}
    </span>
  </div>
</template>

<script>
import DiscCard from "@components/disc/DiscCard.vue";

export default {
  components: {
    DiscCard,
  },
  props: {
    step: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getTranslatedContent(item = {}) {
      const content = item.content ? item.content : '';
      const additional_params = item.content_params ? item.content_params : {};
      return this.$t(content, additional_params);
    }
  }
};
</script>
